import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useSelector } from "react-redux";

// Components
import { Form, Input, Select, Slider, ToggleSwitch } from 'Components';
import { Grid } from "@mui/material";
import { Tooltip, Icons } from "@gpstrackit/gtc-react-controls";

export const EmissionCheck = (props) => {

    const { value, onChange, formRef, triggersRaw, currentAlert, setCurrentAlert } = props
    const { messages } = useIntl()

    useEffect(() => {
        if (value.scans_returning_error == undefined) {
            onChange({
                ...value,
                scans_returning_error: 0
            })
        }

        setTimeout(() => {
            setCurrentAlert({ ...currentAlert, conditions: { isCarb: true } })
        }, 1000)
    }, [value])

    //VARS
    const days = useMemo(() => {
        let values = []
        let day = 1
        while (day < 31) {
            values.push({
                id: day,
                name: `${day}`
            })
            day = day + 1
        }
        return values
    }, [])

    const isValidRequiredItems = (clickNext = false) => {
        let isValid = false
        if (value.scans_returning_error > 0
            || value.carb_submission_fail > 0
            || value.asset_atrisk > 0
            || value.asset_not_compliant > 0
        ) {
            isValid = true
        }

        if (value.trigger && clickNext) {
            isValid = triggersRaw?.length > 0
        }
        return isValid
    }

    return (
        <Form ref={formRef}
            onSubmit={() => {
                return isValidRequiredItems(true)
            }}
        >
            <Grid container justifyContent={'center'} direction={'column'} style={{ paddingTop: 15 }}>
                {
                    (!isValidRequiredItems()) &&
                    <div className="text-danger">
                        {messages["alertsNewAlert_triggerValidation"]}
                    </div>
                }

                { /* scans_returning_error */}
                <Grid item style={{ display: 'flex', margin: '15px 0' }}>
                    <ToggleSwitch
                        id={'scans_returning_error'}
                        small
                        blueToggle
                        optionLabels={["", ""]}
                        label={messages['alertsNewAlert_CARB_ScansReturningError']}
                        checked={value.scans_returning_error == 1}
                        onChange={(newValue) => onChange({ ...value, scans_returning_error: newValue })}
                    />
                </Grid>

                { /* carb_submission_fail */}
                <Grid item style={{ display: 'flex', marginBottom: '15px' }}>
                    <ToggleSwitch
                        id={'carb_submission_fail'}
                        small
                        blueToggle
                        optionLabels={["", ""]}
                        label={messages['alertsNewAlert_CARB_CARBSubmissionFail']}
                        checked={value.carb_submission_fail == 1}
                        onChange={(newValue) => onChange({ ...value, carb_submission_fail: newValue })}
                    />
                </Grid>

                { /* asset_atrisk */}
                <Grid item style={{ display: 'flex', marginBottom: '15px' }}>
                    <ToggleSwitch
                        id={'asset_atrisk'}
                        small
                        blueToggle
                        optionLabels={["", ""]}
                        label={messages['alertsNewAlert_CARB_AssetAtRisk']}
                        checked={value.asset_atrisk == 1}
                        onChange={(newValue) => {
                            if (newValue == 0)
                                onChange({ ...value, asset_atrisk: newValue, asset_atrisk_days: 1 })
                            else
                                onChange({ ...value, asset_atrisk: newValue })
                        }}
                    />
                    <Tooltip
                        placement="top"
                        title={messages['alertsNewAlert_CARB_DaysBeforeComplianceDeadline']}
                        style={{ textAlign: 'center', paddingLeft: '7px' }}
                    >
                        <Icons name="help" size="medium" />
                    </Tooltip>
                </Grid>

                {value.asset_atrisk == 1 &&
                    <Grid item style={{ display: 'flex', marginBottom: '5px' }}>
                        <Slider
                            min={1}
                            max={30}
                            value={value.asset_atrisk_days || 1}
                            onChange={(newValue) => onChange({ ...value, asset_atrisk_days: newValue })}
                            sliderOneColor={false}
                            showValue
                            valueLabelDisplay={'off'}
                        />
                    </Grid>
                }

                { /* asset_not_compliant */}
                <Grid item style={{ display: 'flex', marginBottom: '15px' }}>
                    <ToggleSwitch
                        id={'asset_not_compliant'}
                        small
                        blueToggle
                        optionLabels={["", ""]}
                        label={messages['alertsNewAlert_CARB_AssetIsNotCompliant']}
                        checked={value.asset_not_compliant == 1}
                        onChange={(newValue) => {
                            if (newValue == 0)
                                onChange({ ...value, asset_not_compliant: newValue, asset_not_compliant_days: 1 })
                            else
                                onChange({ ...value, asset_not_compliant: newValue })
                        }}
                    />
                    <Tooltip
                        placement="top"
                        title={messages['alertsNewAlert_CARB_DaysAfterDeadlineSubmission']}
                        style={{ textAlign: 'center', paddingLeft: '7px' }}
                    >
                        <Icons name="help" size="medium" />
                    </Tooltip>
                </Grid>

                {value.asset_not_compliant == 1 &&
                    <Grid item style={{ display: 'flex', marginBottom: '5px' }}>
                        <Slider
                            min={1}
                            max={30}
                            value={value.asset_not_compliant_days || 1}
                            onChange={(newValue) => onChange({ ...value, asset_not_compliant_days: newValue })}
                            sliderOneColor={false}
                            showValue
                            valueLabelDisplay={'off'}
                        />
                    </Grid>
                }

            </Grid >
        </Form >
    );
}
